import { z } from "zod";
export const kateHistorySchema = z.array(z.object({ role: z.enum(["user", "assistant"]), content: z.string().trim().min(1).max(2000) }).strict()).max(8);
export type KateMessage = z.infer<typeof kateHistorySchema>[number];
export const kateModeSchema = z.enum(["build", "edit"]);
export type KateMode = z.infer<typeof kateModeSchema>;
